(() => {
const slugify = (value = '') =>
value.toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const categoryLabels = {
blockout: 'Blockout',
light_filtering: 'Light Filtering',
sunscreen: 'Sunscreen',
architectural: 'Architectural & Commercial'
};

const categoryContent = {
blockout: {heading: 'Blockout fabric collections',intro: 'Complete privacy, room darkening and dependable everyday performance.'},
light_filtering: {heading: 'Light-filtering fabric collections',intro: 'Soft translucent fabrics that diffuse daylight while keeping rooms bright.'},
sunscreen: {heading: 'Sunscreen fabric collections',intro: 'Reduce glare and heat while maintaining daytime outward visibility.'},
double: {heading: 'Double roller combinations',intro: 'Combine a front blockout blind with a rear sunscreen or light-filtering blind.'},
architectural: {heading: 'Architectural and commercial collections',intro: 'Commercial-grade, fire-tested and high-performance ranges for large projects.'}
};

const descriptionFor = (item) => {
if (item.description) return item.description;
if (item.category === 'blockout') return 'A custom-made blackout collection created for privacy, room darkening and a refined architectural finish.';
if (item.category === 'light_filtering') return 'A light-filtering collection that softens natural light while maintaining a bright and comfortable interior.';
if (item.category === 'sunscreen') return `A sunscreen collection designed to reduce glare and solar heat${item.openness ? ` with ${item.openness} openness` : ''}.`;
return 'A high-performance architectural collection for commercial and technically demanding projects.';
};

const init = (section) => {
if (!section || section.dataset.ready === 'true') return;
section.dataset.ready = 'true';

const categoryButtons = [...section.querySelectorAll('[data-category]')];
const heading = section.querySelector('[data-collection-heading]');
const intro = section.querySelector('[data-collection-intro]');
const emptyState = section.querySelector('[data-empty-state]');
const collectionArea = section.querySelector('[data-collection-area]');
const grid = section.querySelector('[data-library-grid]');
const assetBase = section.dataset.fabricAssetBase || '';
const builderUrl = section.dataset.builderUrl || '/pages/roller-blind-builder';
const library = window.LUX_ROLLER_FABRICS;
let assetMap = {};
try {
  const assetMapNode = section.querySelector('#LuxRollerCollectionAssetMap');
  if (assetMapNode) assetMap = JSON.parse(assetMapNode.textContent || '{}');
} catch (error) {
  console.warn('LUXWORLD roller collection asset map could not be parsed.', error);
}
if (!grid) return;
if (!library || !Array.isArray(library.collections)) {
grid.innerHTML = `<div class="lux-crystal__library-error">The fabric library has not loaded. Confirm that <strong>lux-roller-fabric-library.js</strong> is saved in Assets and loaded before <strong>lux-roller-blinds-crystal.js</strong>.</div>`;
if (emptyState) emptyState.hidden = true;
return;
}
const imageUrl = (filename) => assetMap[filename] || `${assetBase}${filename}`;

const modal=document.createElement('div');
modal.className='lux-crystal__fabric-modal';
modal.hidden=true;
modal.innerHTML=`<button class="lux-crystal__fabric-modal-backdrop" type="button" aria-label="Close zoom"></button><div class="lux-crystal__fabric-modal-dialog" role="dialog" aria-modal="true"><button class="lux-crystal__fabric-modal-close" type="button" aria-label="Close">×</button><h3 data-zoom-title>Fabric sample</h3><p>High-resolution fabric view. Pinch to zoom on mobile or use the controls.</p><div class="lux-crystal__fabric-zoom-stage"><img data-zoom-image alt=""></div><div class="lux-crystal__fabric-zoom-controls"><button type="button" data-zoom-minus>−</button><button type="button" data-zoom-reset>Reset</button><button type="button" data-zoom-plus>+</button></div></div>`;
section.append(modal);
const zoomImg=modal.querySelector('[data-zoom-image]'),zoomTitle=modal.querySelector('[data-zoom-title]');
let scale=1;
const applyZoom=()=>zoomImg.style.transform=`scale(${scale})`;
const closeZoom=()=>{modal.hidden=true;document.documentElement.style.overflow='';scale=1;applyZoom()};
const openZoom=(src,title)=>{zoomImg.src=src;zoomImg.alt=`${title} fabric sample`;zoomTitle.textContent=title;scale=1;applyZoom();modal.hidden=false;document.documentElement.style.overflow='hidden'};
modal.querySelector('.lux-crystal__fabric-modal-backdrop').onclick=closeZoom;
modal.querySelector('.lux-crystal__fabric-modal-close').onclick=closeZoom;
modal.querySelector('[data-zoom-minus]').onclick=()=>{scale=Math.max(1,scale-.25);applyZoom()};
modal.querySelector('[data-zoom-plus]').onclick=()=>{scale=Math.min(4,scale+.25);applyZoom()};
modal.querySelector('[data-zoom-reset]').onclick=()=>{scale=1;applyZoom()};

grid.innerHTML = library.collections.map((item) => {
const collectionCode = slugify(item.collection);
const firstColour = item.colours?.[0];
const coverImage = item.hero_image ? imageUrl(item.hero_image) : (firstColour ? imageUrl(firstColour.file) : '');
const opennessBadge = item.openness ? `<span class="lux-crystal__badge">${item.openness} openness</span>` : '';
const doubleCompatible = item.category === 'blockout' || item.category === 'light_filtering' || item.category === 'sunscreen';
const colourItems = (item.colours || []).map((colour) => `
<button class="lux-crystal__colour-item" type="button" data-fabric-zoom="${imageUrl(colour.file)}" data-fabric-label="${colour.name} — ${item.collection}" aria-label="Zoom ${colour.name}">
<span class="lux-crystal__zoom-mark">⌕</span>
<img src="${imageUrl(colour.file)}" alt="${colour.name} ${item.collection} fabric" width="500" height="500" loading="lazy">
<span>${colour.name}</span>
</button>`).join('');
return `
<article class="lux-crystal__collection-card" data-collection-card data-collection-category="${item.category}" data-double-compatible="${doubleCompatible}">
<div class="lux-crystal__collection-media">${coverImage ? `<img src="${coverImage}" alt="${item.collection} fabric collection" width="900" height="560" loading="lazy">` : ''}</div>
<div class="lux-crystal__collection-body">
<div class="lux-crystal__meta"><span class="lux-crystal__badge">${categoryLabels[item.category] || item.category}</span>${opennessBadge}<span class="lux-crystal__badge">${item.colours?.length || 0} colours</span></div>
<h3>${item.collection}</h3><p>${descriptionFor(item)}</p>
<div class="lux-crystal__collection-links">
<button class="lux-crystal__btn lux-crystal__btn--outline lux-crystal__colour-toggle" type="button" aria-expanded="false">View colours</button>
<a class="lux-crystal__btn lux-crystal__btn--studio" href="${builderUrl}?category=${encodeURIComponent(item.category)}&collection=${encodeURIComponent(collectionCode)}">Enter Design Studio™</a>
</div>
<div class="lux-crystal__colour-panel"><div class="lux-crystal__colour-grid">${colourItems}</div></div>
</div></article>`;
}).join('');

const cards = [...section.querySelectorAll('[data-collection-card]')];

section.querySelectorAll('.lux-crystal__colour-toggle').forEach((button) => {
button.addEventListener('click', () => {
const card = button.closest('.lux-crystal__collection-card');
const open = card.classList.toggle('is-colours-open');
button.textContent = open ? 'Hide colours' : 'View colours';
button.setAttribute('aria-expanded', open ? 'true' : 'false');
});
});

section.querySelectorAll('[data-fabric-zoom]').forEach(btn=>{
btn.addEventListener('click',()=>openZoom(btn.dataset.fabricZoom,btn.dataset.fabricLabel||'Fabric sample'));
});

const selectCategory = (category, scroll = true) => {
categoryButtons.forEach((button) => {
const active = button.dataset.category === category;
button.classList.toggle('is-active', active);
button.setAttribute('aria-pressed', active ? 'true' : 'false');
});
let visibleCount = 0;
cards.forEach((card) => {
const visible = card.dataset.collectionCategory === category || (category === 'double' && card.dataset.doubleCompatible === 'true');
card.hidden = !visible;
if (visible) visibleCount += 1;
});
const content = categoryContent[category];
if (heading && content) heading.textContent = content.heading;
if (intro && content) intro.textContent = content.intro;
if (emptyState) emptyState.hidden = visibleCount > 0;
if (scroll) collectionArea?.scrollIntoView({behavior: 'smooth', block: 'start'});
};

categoryButtons.forEach((button) => button.addEventListener('click', () => selectCategory(button.dataset.category)));
selectCategory('blockout', false);
};

const initAll = () => document.querySelectorAll('.lux-crystal').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.lux-crystal')));
})();